// LEGACY: Uses @ion/components for the underlying select. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';

import { MrInputSelect } from '@ion/components';
import { Stack } from '@metarouter-private/mr-mui';

import { CONSENT_MODES } from '@ion/api/consent-modes/modes';
import ConsentModeExternalAlert from 'app/components/consent-mode-select/ConsentModeExternalAlert';
import buildConsentModeSelectProps from './buildConsentModeSelectProps';

export default function ConsentModeSelect({ onChange, ...additionalProps }) {
  const props = buildConsentModeSelectProps({ onChange, ...additionalProps });
  const isExternal = additionalProps.value === CONSENT_MODES.external;

  return (
    <>
      <MrInputSelect {...props} />
      {isExternal && (
        <Stack mb={3}>
          <ConsentModeExternalAlert />
        </Stack>
      )}
    </>
  );
}

ConsentModeSelect.propTypes = {
  ...MrInputSelect.propTypes,
  // overrides from MrInputSelect that buildConsentModeSelectProps handles
  name: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
